var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 1 .217.005A5 5 0 0 1 11 6l-.005.217A5 5 0 1 1 6 1zm0 1a4 4 0 1 0 0 8l.2-.005A4 4 0 0 0 10 6l-.005-.2A4 4 0 0 0 6 2zm.354 5.646a.5.5 0 1 1-.708.708.5.5 0 0 1 .708-.708zM6 3.5l.09.008A.5.5 0 0 1 6.5 4v2.5a.5.5 0 1 1-1 0V4l.008-.09A.5.5 0 0 1 6 3.5z",
    fill: "#FF4A4A",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.703bfc0ee98d4d38617c1f35c0f9a567.svg";
export { ForwardRef as ReactComponent };